import { Empty } from "antd";
import React, { memo } from "react";

function CustomEmpty({ ...rest }) {
  return (
    <Empty
      // image={Empty.PRESENTED_IMAGE_SIMPLE}
      {...rest}
    />
  );
}

export default memo(CustomEmpty);
